export default {
      id: "ar_veloroutes-usage",
      viewBox: "0 0 110 100",
      url: "../dist/images/" + "sprite.svg#ar_veloroutes-usage",
      toString: function () {
        return this.url;
      }
    }